import axios from "axios";
import { DISCOUNT_MASTERS } from "../../types/DiscountMasterType";

const getAllDiscountMaster = (data) => {
	return {
		type: DISCOUNT_MASTERS,
		payload: data,
	};
};

export const loadAllDiscountMaster = ({ page, limit, discount_type, status }) => {
	return async (dispatch) => {
		try {
			let url = `discount-master?page=${page}&count=${limit}`;
			if (discount_type) url += `&discount_type=${discount_type}`;
			if (status !== undefined) url += `&status=${status}`;
			
			const { data } = await axios.get(url);
			dispatch(getAllDiscountMaster(data));
		} catch (error) {
			console.log(error.message);
		}
	};
};
